"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertRemToPixels = void 0;

require("core-js/modules/es.parse-float.js");

var convertRemToPixels = function convertRemToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

exports.convertRemToPixels = convertRemToPixels;